// $(document).ready(function () {
//   $(document).on('click', '.bulk-buy-pre-col', function(){
//     $('body').css('overflow', 'hidden');
//     $('.bulk-buy-items-pop-wrapper').fadeIn(800);
//     $('.bulk-buy-items-pop-main').addClass('active-popup');
//   });
//   $(document).on('click', '.cross-svg', function(){
//     closeOptPopup();
//     // if(document.querySelector('.bulk-buy-row.data-off')){
//     //   document.querySelector('.bulk-buy-row').classList.remove('data-off');
//     // }
//   });
// });

// // close option popup
// function closeOptPopup(){
//   if(document.querySelector('.bulk-buy-items-pop-main.it-change')){
//     alert('There are unsaved changes. Ensure that you have save your changes before proceeding.');
//     // $('.bulk-buy-items-pop-main').scrollTop(document.querySelector('span.cstm-apl-btn').offsetTop);
//   }else{
//     $('body').css('overflow', 'unset');
//     $('.bulk-buy-items-pop-wrapper').fadeOut(800);
//     $('.bulk-buy-items-pop-main').removeClass('active-popup');
//   }
// }

// // js
// document.querySelectorAll('.bul-buy-row>input[type="radio"]').forEach((ele)=>{
//   ele.onchange = function(){
//     let getWeigth = this.dataset.title;
//     $('.bulk-buy-items-pop-header h2').text(getWeigth);
//     $('#custm-title-weight-product').text(getWeigth);
//     let price = this.dataset.price;
//     price = moneyFormate(price);
//     document.querySelector('.bulk-buy-cart--total__price span').textContent = price;
//     document.querySelector('.bulk-buy-cart--total__price').setAttribute('data-price',this.dataset.price);
//     document.querySelector('.bbp-subT-price').textContent = price;
//     addPrice();
//     setWeigth();
//   }
// })
// document.querySelectorAll('.top-content').forEach((ele)=>{
//   ele.addEventListener('click',function(){
//     $(this.closest('.bulk-buy-top-content').querySelector('.bulk-buy-bottom-content')).slideToggle(300);
//     if(this.classList.contains('its-open')){
//       this.classList.remove('its-open');
//     }else{
//       this.classList.add('its-open');
//     }
//   });
// })
// document.querySelectorAll('.bulk-buy-bottom-content>input[type="radio"]').forEach((ele)=>{
//     ele.onchange = function(){
//       let i = this.closest('.bulk-buy-item-main').dataset.index;
//       let getText = this.value.trim();
//       this.closest('.bulk-buy-top-content').querySelector('.top-left-content>p').textContent = getText;
//       document.querySelector('.bulk-buy-items-pop-main').classList.add('it-change');
//     }
// });
// document.querySelector('.bulk-buy-cart_packing__trigger').onclick = function(){
//     shipPopup();
// }
// document.querySelectorAll('.pop-customize-tab-titles span.pop-ctz-tab-title').forEach((ele)=>{
//     ele.addEventListener('click',function(){
//         let i = this.dataset.index;
//         document.querySelectorAll('.pop-customize-tab-titles span.pop-ctz-tab-title').forEach((ele)=>{
//             ele.classList.remove('active-tab');
//         });
//         this.classList.add('active-tab');
//         document.querySelectorAll('.pop-customize-box-tab-cotent').forEach((ele)=>{
//             ele.classList.remove('active-tab-con');
//         });
//         document.querySelector('.pop-customize-box-tab-cotent[data-index="'+i+'"]').classList.add('active-tab-con');
//     })
// });

// // save customize 
// function saveCustomize() {
//     document.querySelector('.bulk-buy-cart-items__main ul.bbc_add__items').innerHTML = '';
//     let index = 0;
//     document.querySelectorAll('.pop-ctz-tab-beef-up-item-main quantity-input.quantity').forEach((ele)=>{
//     if(ele.querySelector('.quantity__input').value > 0){
//       index = index+1;
//       let i = ele.closest('.pop-ctz-tab-beef-up-item-main').dataset.index, 
//       id = ele.dataset.id,
//       qty = ele.querySelector('.quantity__input').value,
//       price = ele.dataset.price,
//       itemTitle = ele.closest('.pop-ctz-tab-beef-up-item-main').querySelector('span.pop-ctz-tab-beef-item-title>span').textContent;
//       let itemHtml = `<li data-index="${i}" data-id="${id}" data-qty="${qty}" data-price="${price}" data-prop="add item ${index}">
//                           <span class="bbca_pro-title">${itemTitle}</span>
//                           <span class="bbc-add__quatity_mange">
//                             <span class="bbcai_quatity">x${qty}</span>
//                             <span class="bbca_item__remove" data-remove="${i}">
//                               <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="width:15px; height:15px" viewBox="0 0 24 24" preserveAspectRatio="none" width="24" height="24">
//                                 <g><path d="M18 6 6 18M6 6l12 12" stroke="#fff" fill="none" stroke-width="2px"></path></g>
//                               </svg>
//                             </span>
//                           </span>
//                         </li>`;
//       itemHtml = new DOMParser().parseFromString(itemHtml, 'text/html').querySelector('li');
//       document.querySelector('.bbc_add__items').appendChild(itemHtml);
//       document.querySelector('.bulk-buy-cart-add_items__main').style.display = 'block';
//     }
//   });
//   addPrice();
//   if(!document.querySelectorAll('.bulk-buy-cart-items__main ul.bbc_add__items li').length){
//       document.querySelector('.bulk-buy-cart-add_items__main').style.display = 'none';
//   }
//   removeAddonItems();
// }

// // set all item weight 
// function setWeigth(){
//   document.querySelectorAll('.bbc-pro-qty').forEach((ele)=>{
//     let weight = Number(ele.dataset.qty);
//     let mainWeight = document.querySelector('.bul-buy-row>input[type=radio]:checked').dataset.weight.replace('kg','').replace('(','');
//     mainWeight = Number(mainWeight.replace(')',''));
//     let oneP = mainWeight/100,
//         raw = oneP*weight,
//         nearest = Math.round(raw);
//     // ITG: snap to whole number if within rounding tolerance of percentage precision
//     let setW;
//     if(Math.abs(raw - nearest) < 0.02){
//       setW = String(nearest);
//     }else{
//       setW = raw.toFixed(2);
//       if(setW.includes('.00')){
//         setW = setW.replace('.00','');
//       }
//     }
//     if(ele.querySelector('.content-weight')){
//       ele.querySelector('.content-weight').textContent = setW+'kg';
//     }else{
//       ele.textContent = setW+'kg';
//     }
//   });
// }


// // add price in product
// function addPrice() {  
//   let addPrice = getAllPrice(),
//    pPrice = document.querySelector('.bulk-buy-cart--total__price').dataset.price,
//    tPrice = Number(addPrice)+Number(pPrice),
//    itemPrice = moneyFormate(tPrice),
//    emiPrice = moneyFormate(tPrice/4);
//    document.querySelectorAll('.bulk-buy-cart-header .payment-widget-main span.zip-price').forEach((ele)=>{
//      ele.textContent = emiPrice;
//    })
//    document.querySelector('.bulk-buy-cart--total__price span').textContent = itemPrice;
//    document.querySelector('.bbp-subT-price').textContent = itemPrice;
// }

// // get plus item price
// function getAllPrice() {
//   let allPrice = 0;
//   document.querySelectorAll('.bulk-buy-cart-items__main ul.bbc_add__items li').forEach((ele)=>{
//     let price = ele.dataset.price,
//     qty = ele.dataset.qty;
//     price = price*qty;
//     allPrice = Number(price)+Number(allPrice);
//   });
//   return allPrice;
// }

// // remove add item 
// function removeAddonItems() {
//   document.querySelectorAll('span.bbca_item__remove').forEach((ele)=>{
//     ele.addEventListener('click',function(){
//       let i = this.dataset.remove;
//       document.querySelector('.pop-ctz-tab-beef-up-item-main[data-index="'+i+'"] input.quantity__input').value = 0;
//       this.closest('li').remove();
//       if(!document.querySelectorAll('.bulk-buy-cart-items__main ul.bbc_add__items li').length){
//           document.querySelector('.bulk-buy-cart-add_items__main').style.display = 'none';
//       }
//       addPrice();
//     })
//   })
// }

// // create bulk bundle
// function createBulkData(cart,pResponse,random){
//   let itemQty = [],itemId = [],itemData = [];
//   document.querySelectorAll('ul.bbc_add__items li').forEach((ele)=>{
//     itemId.push(ele.dataset.id);
//     itemQty.push(ele.dataset.qty);
//   });
//   for (var i in itemId)
//   itemData.push({id: itemId[i],quantity: itemQty[i],properties:{ _bulkBoxId: random}});
//   return {
//     items:itemData,
//     sections:cart.getSectionsToRender().map((section) => section.id),
//     sections_url:window.location.pathname
//   }
// }

// // add bulk buy
// document.querySelector('button#bulk-view-cart').onclick = function(){
//   this.setAttribute('disabled', true);
//   this.classList.add('loading');
//   this.querySelector('.loading__spinner').classList.remove('hidden');
//   let random = new Date().getTime();
//   bulkBuyAdd(true,random);
// }

// // get all properties
// function getAllProp(random){
//   let getProp = {
//     _bulkBox: true,
//     _mainBulkBoxId:random
//   }
//   document.querySelectorAll('.bulk-buy-cart-items__main ul.bb-cart__items li').forEach((ele,i)=>{
//     i++;
//     let item = 'item '+i,
//     propLast = ele.querySelector('.bbc-pro-info').textContent.trim();
//     getProp[item] = propLast;
//   });
//   document.querySelectorAll('.bulk-buy-cart-items__main ul.bbc_add__items li').forEach((ele,i)=>{
//     i++;
//     let item = 'add item '+i,
//     propLast = ele.querySelector('.bbca_pro-title').textContent.trim();
//     getProp[item] = propLast;
//   });
//   getProp['Pack my beef in'] = document.querySelector('.pop-customize-box-tab-cotent select.pop-select').value;
//   if(document.querySelector('.pop-customize-box-tab-cotent textarea.pop-input').value != ''){
//     getProp['Packing request'] = document.querySelector('.pop-customize-box-tab-cotent textarea.pop-input').value;
//   }
//   return getProp;
// }

// // bulk buy add to cart 
// async function bulkBuyAdd(check,random,prevRes) {
//   let getProp = getAllProp(random);
//   let cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer'),
//       mainId = document.querySelector('[name="bulk-buy-product"]:checked').value,
//       qty = 1,
//       data = {
//         id:mainId,
//         quantity:qty,
//         properties:getProp,
//         sections:cart.getSectionsToRender().map((section) => section.id),
//         sections_url:window.location.pathname
//       };
//   check ? data = data : data = await createBulkData(cart,prevRes,random);
//   fetch("/cart/add.js", {
//     method: "POST",
//     headers: {
//         "Content-Type": "application/json"
//     },
//     body: JSON.stringify(data)
//   }).then(response=>response.json()).then(response=>{
//     if(document.querySelectorAll('.bulk-buy-cart-items__main ul.bbc_add__items li').length && check){
//       bulkBuyAdd(false,random,response)
//     }else{
//       let cartDrawer = document.querySelector('cart-drawer');
//       let cartFooter = document.getElementById('main-cart-footer');
//       if (cartFooter) cartFooter.classList.toggle('is-empty', response.item_count === 0);
//       if (cartDrawer) cartDrawer.classList.toggle('is-empty', response.item_count === 0);
//       cart ? cart.renderContents(response) : window.location = window.routes.cart_url;
//       setTimeout(()=>{
//         document.querySelector('button#bulk-view-cart').classList.remove('loading');
//         document.querySelector('button#bulk-view-cart').querySelector('.loading__spinner').classList.add('hidden');
//         document.querySelector('button#bulk-view-cart').removeAttribute('disabled');
//       },200);
//     }
//   }).catch(error=>{
//       console.error("Error adding bundle to cart:", error)
//   })
// }

// // save bulk buy
// if(document.querySelector('.custom-section-popup.bulk-buy-customize-popup button.save-btn')){
//   document.querySelector('.custom-section-popup.bulk-buy-customize-popup button.save-btn').onclick = function(){
//     saveCustomize();
//   }
// }

// // apply option changes
// document.querySelector('span.cstm-apl-btn>a').addEventListener('click',function(evt){
//   evt.preventDefault();
//   if(document.querySelector('.bulk-buy-row.data-off')){
//     document.querySelector('.bulk-buy-row').classList.remove('data-off');
//   }
//   optSave();
// });

// function optSave(){
//   document.querySelectorAll('.bulk-buy-bottom-content>input[type="radio"]:checked').forEach((ele)=>{
//       let i = ele.closest('.bulk-buy-item-main').dataset.index;
//       let getText = ele.value.trim();
//       ele.closest('.bulk-buy-top-content').querySelector('.top-left-content>p').textContent = getText;
//       document.querySelector('.bb-cart__items li[data-index="'+i+'"] .bbc-var-title').textContent = getText;
//   });
//   document.querySelector('.bulk-buy-items-pop-main').classList.remove('it-change');
//   closeOptPopup();
// }

// // clear bulk buy
// document.querySelector('span.clear-cart-bulk-buy').addEventListener('click',function(){
//   if(!document.querySelector('.bulk-buy-row.data-off')){
//     document.querySelector('.bulk-buy-row').classList.add('data-off');
//   }
//   document.querySelector('.bul-buy-row>input[type=radio]:checked').checked = false;
//   document.querySelectorAll('.bulk-buy-item-main').forEach((ele)=>{
//     ele.querySelector('label.bb-category').click();
//   });
//   $('.bulk-buy-bottom-content').slideUp(0);
//   $('.top-content').removeClass('its-open');
//   document.querySelector('.bulk-buy-items-pop-main').classList.remove('it-change');
// });

// $(document).mouseup(function(e) {
//   var container = $('.bulk-buy-items-pop-main');
//   if($('.bulk-buy-items-pop-main.active-popup').length){
//     if (!container.is(e.target) && container.has(e.target).length === 0){
//       closeOptPopup();
//     }
//   }
//   if($('div#shopify-section-custom-pop-up.its-show').length){
//     container = $('.pop-up-main');
//     if (!container.is(e.target) && container.has(e.target).length === 0){
//       shipPopupClose();
//     }
//   }
// })




$(document).ready(function () {
  // On the product page the cuts selector is rendered inline, so the image must NOT
  // open a popup. The click-to-open popup is kept only on the bulk-buy page.
  if(!isProductTemplate()){
    $(document).on('click', '.bulk-buy-pre-col', function(){
      $('body').css('overflow', 'hidden');
      $('.bulk-buy-items-pop-wrapper').fadeIn(800);
      $('.bulk-buy-items-pop-main').addClass('active-popup');
    });
    $(document).on('click', '.cross-svg', function(){
      closeOptPopup();
    });
  }
});

// close option popup
function closeOptPopup(){
  if(document.querySelector('.bulk-buy-items-pop-main.it-change')){
    alert('There are unsaved changes. Ensure that you have save your changes before proceeding.');
  }else{
    $('body').css('overflow', 'unset');
    $('.bulk-buy-items-pop-wrapper').fadeOut(800);
    $('.bulk-buy-items-pop-main').removeClass('active-popup');
  }
}

function isProductTemplate(){
  if(/\/products\//.test(window.location.pathname)) return true;
  if(document.body && document.body.classList.contains('template-product')) return true;
  return false;
}

document.addEventListener('DOMContentLoaded', function(){
  if(!isProductTemplate()) return; 
  var anyChecked = document.querySelector('[name="bulk-buy-product"]:checked');
  if(!anyChecked){
    var firstRadio = document.querySelector('[name="bulk-buy-product"]');
    if(firstRadio){
      firstRadio.checked = true;
      firstRadio.dispatchEvent(new Event('change'));
      var row = document.querySelector('.bulk-buy-row.data-off');
      if(row) row.classList.remove('data-off');
    }
  }
});

document.querySelectorAll('.bul-buy-row>input[type="radio"]').forEach((ele)=>{
  ele.onchange = function(){
    let getWeigth = this.dataset.title;
    $('.bulk-buy-items-pop-header h2').text(getWeigth);
    $('#custm-title-weight-product').text(getWeigth);
    let price = this.dataset.price;
    price = moneyFormate(price);
    document.querySelector('.bulk-buy-cart--total__price span').textContent = price;
    document.querySelector('.bulk-buy-cart--total__price').setAttribute('data-price',this.dataset.price);
    document.querySelector('.bbp-subT-price').textContent = price;
    addPrice();
    setWeigth();
  }
});

// Delegated so they work for inline rows (product page) and popup rows (bulk-buy
// page) alike, regardless of when the markup is rendered.
$(document).on('click', '.top-content', function(){
  var top = this.closest('.bulk-buy-top-content');
  if(!top) return;
  $(top.querySelector('.bulk-buy-bottom-content')).slideToggle(300);
  this.classList.toggle('its-open');
});

$(document).on('change', '.bulk-buy-bottom-content input[type="radio"]', function(){
  var row = this.closest('.bulk-buy-item-main');
  if(!row) return;
  var i = row.dataset.index;
  var getText = this.value.trim();
  // Update the visible gold cut-type label on this row.
  var label = row.querySelector('.top-left-content p');
  if(label) label.textContent = getText;
  // Product page: cuts UI is inline (no Apply step required), so commit the
  // selection straight into the hidden source list that feeds cart properties.
  if(isProductTemplate()){
    var cartTitleEl = document.querySelector('.bb-cart__items li[data-index="'+i+'"] .bbc-var-title');
    if(cartTitleEl) cartTitleEl.textContent = getText;
  }
  var popMain = document.querySelector('.bulk-buy-items-pop-main');
  if(popMain) popMain.classList.add('it-change');
  // A new option was picked, so any previous "Applied ✓" confirmation is now stale.
  bbResetApplyLabel();
});

var packingTrigger = document.querySelector('.bulk-buy-cart_packing__trigger');
if(packingTrigger){
  packingTrigger.onclick = function(){
    if(typeof shipPopup === 'function') shipPopup();
  }
}

document.querySelectorAll('.pop-customize-tab-titles span.pop-ctz-tab-title').forEach((ele)=>{
    ele.addEventListener('click',function(){
        let i = this.dataset.index;
        document.querySelectorAll('.pop-customize-tab-titles span.pop-ctz-tab-title').forEach((ele)=>{
            ele.classList.remove('active-tab');
        });
        this.classList.add('active-tab');
        document.querySelectorAll('.pop-customize-box-tab-cotent').forEach((ele)=>{
            ele.classList.remove('active-tab-con');
        });
        document.querySelector('.pop-customize-box-tab-cotent[data-index="'+i+'"]').classList.add('active-tab-con');
    })
});

function saveCustomize() {
    document.querySelector('.bulk-buy-cart-items__main ul.bbc_add__items').innerHTML = '';
    let index = 0;
    document.querySelectorAll('.pop-ctz-tab-beef-up-item-main quantity-input.quantity').forEach((ele)=>{
    if(ele.querySelector('.quantity__input').value > 0){
      index = index+1;
      let i = ele.closest('.pop-ctz-tab-beef-up-item-main').dataset.index, 
      id = ele.dataset.id,
      qty = ele.querySelector('.quantity__input').value,
      price = ele.dataset.price,
      itemTitle = ele.closest('.pop-ctz-tab-beef-up-item-main').querySelector('span.pop-ctz-tab-beef-item-title>span').textContent;
      let itemHtml = `<li data-index="${i}" data-id="${id}" data-qty="${qty}" data-price="${price}" data-prop="add item ${index}">
                          <span class="bbca_pro-title">${itemTitle}</span>
                          <span class="bbc-add__quatity_mange">
                            <span class="bbcai_quatity">x${qty}</span>
                            <span class="bbca_item__remove" data-remove="${i}">
                              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="width:15px; height:15px" viewBox="0 0 24 24" preserveAspectRatio="none" width="24" height="24">
                                <g><path d="M18 6 6 18M6 6l12 12" stroke="#fff" fill="none" stroke-width="2px"></path></g>
                              </svg>
                            </span>
                          </span>
                        </li>`;
      itemHtml = new DOMParser().parseFromString(itemHtml, 'text/html').querySelector('li');
      document.querySelector('.bbc_add__items').appendChild(itemHtml);
      document.querySelector('.bulk-buy-cart-add_items__main').style.display = 'block';
    }
  });
  addPrice();
  if(!document.querySelectorAll('.bulk-buy-cart-items__main ul.bbc_add__items li').length){
      document.querySelector('.bulk-buy-cart-add_items__main').style.display = 'none';
  }
  removeAddonItems();
}

function setWeigth(){
  document.querySelectorAll('.bbc-pro-qty').forEach((ele)=>{
    let weight = Number(ele.dataset.qty);
    let mainWeight = document.querySelector('.bul-buy-row>input[type=radio]:checked').dataset.weight.replace('kg','').replace('(','');
    mainWeight = Number(mainWeight.replace(')',''));
    let oneP = mainWeight/100,
        raw = oneP*weight,
        nearest = Math.round(raw);
    let setW;
    if(Math.abs(raw - nearest) < 0.02){
      setW = String(nearest);
    }else{
      setW = raw.toFixed(2);
      if(setW.includes('.00')){
        setW = setW.replace('.00','');
      }
    }
    if(ele.querySelector('.content-weight')){
      ele.querySelector('.content-weight').textContent = setW+'kg';
    }else{
      ele.textContent = setW+'kg';
    }
  });
}

function addPrice() {  
  let addPrice = getAllPrice(),
   pPrice = document.querySelector('.bulk-buy-cart--total__price').dataset.price,
   tPrice = Number(addPrice)+Number(pPrice),
   itemPrice = moneyFormate(tPrice),
   emiPrice = moneyFormate(tPrice/4);
   document.querySelectorAll('.bulk-buy-cart-header .payment-widget-main span.zip-price').forEach((ele)=>{
     ele.textContent = emiPrice;
   })
   document.querySelector('.bulk-buy-cart--total__price span').textContent = itemPrice;
   document.querySelector('.bbp-subT-price').textContent = itemPrice;
}

function getAllPrice() {
  let allPrice = 0;
  document.querySelectorAll('.bulk-buy-cart-items__main ul.bbc_add__items li').forEach((ele)=>{
    let price = ele.dataset.price,
    qty = ele.dataset.qty;
    price = price*qty;
    allPrice = Number(price)+Number(allPrice);
  });
  return allPrice;
}

function removeAddonItems() {
  document.querySelectorAll('span.bbca_item__remove').forEach((ele)=>{
    ele.addEventListener('click',function(){
      let i = this.dataset.remove;
      document.querySelector('.pop-ctz-tab-beef-up-item-main[data-index="'+i+'"] input.quantity__input').value = 0;
      this.closest('li').remove();
      if(!document.querySelectorAll('.bulk-buy-cart-items__main ul.bbc_add__items li').length){
          document.querySelector('.bulk-buy-cart-add_items__main').style.display = 'none';
      }
      addPrice();
    })
  })
}

// Collect the PLUS add-on items as separate cart line items, linked to the main
// box via _bulkBoxId so they group together in the cart/checkout.
function getAddonLineItems(random){
  var addons = [];
  document.querySelectorAll('.bulk-buy-cart-items__main ul.bbc_add__items li').forEach(function(ele){
    if(!ele.dataset.id) return;
    addons.push({
      id: ele.dataset.id,
      quantity: Number(ele.dataset.qty) || 1,
      properties: { _bulkBoxId: random }
    });
  });
  return addons;
}

$(document).on('click', 'button#bulk-view-cart', function(){
  var selectedRadio = document.querySelector('[name="bulk-buy-product"]:checked');
  if(!selectedRadio){
    var firstRadio = document.querySelector('[name="bulk-buy-product"]');
    if(firstRadio){
      firstRadio.checked = true;
      firstRadio.dispatchEvent(new Event('change'));
    } else {
      alert('Please select a beast size first');
      return;
    }
  }
  this.setAttribute('disabled', true);
  this.classList.add('loading');
  var spinner = this.querySelector('.loading__spinner');
  if(spinner) spinner.classList.remove('hidden');
  let random = new Date().getTime();
  bulkBuyAdd(random);
});

function getAllProp(random){
  let getProp = {
    _bulkBox: true,
    _mainBulkBoxId:random
  }
  if(isProductTemplate()){
    // PRODUCT PAGE: the cuts UI is inline. Read each cut's CURRENT selection straight
    // from its checked radio (the source of truth) so the cart always reflects the
    // customer's choice — no dependency on syncing the hidden .bb-cart__items mirror.
    // Output format ("Title - Cut") matches what the cart template splits on " -".
    document.querySelectorAll('.bulk-buy-item-main').forEach(function(row, idx){
      var titleEl = row.querySelector('.top-left-content h4');
      var checked = row.querySelector('.bulk-buy-bottom-content input[type="radio"]:checked');
      var selEl = row.querySelector('.top-left-content p');
      var title = titleEl ? titleEl.textContent.trim() : '';
      var cut = checked ? checked.value.trim() : (selEl ? selEl.textContent.trim() : '');
      getProp['item ' + (idx + 1)] = title + ' - ' + cut;
    });
  } else {
    // BULK-BUY PAGE: read from the visible "Your Order" list (unchanged behaviour).
    document.querySelectorAll('.bulk-buy-cart-items__main ul.bb-cart__items li').forEach((ele,i)=>{
      i++;
      let item = 'item '+i,
      propLast = ele.querySelector('.bbc-pro-info').textContent.trim();
      getProp[item] = propLast;
    });
  }
  document.querySelectorAll('.bulk-buy-cart-items__main ul.bbc_add__items li').forEach((ele,i)=>{
    i++;
    let item = 'add item '+i,
    propLast = ele.querySelector('.bbca_pro-title').textContent.trim();
    getProp[item] = propLast;
  });
  var packSelect = document.querySelector('.pop-customize-box-tab-cotent select.pop-select');
  if(packSelect && packSelect.value){
    getProp['Pack my beef in'] = packSelect.value;
  }
  var packReq = document.querySelector('.pop-customize-box-tab-cotent textarea.pop-input');
  if(packReq && packReq.value !== ''){
    getProp['Packing request'] = packReq.value;
  }
  return getProp;
}

// Low-level POST to /cart/add.js. Throws on a Shopify/HTTP error so the caller
// can react (e.g. fall back to adding items one at a time). Shopify prices every
// line item from the variant itself — passing the correct variant id is what makes
// the cart total correct; you cannot send a custom price here.
async function addItemsToCart(items, sections){
  var body = { items: items };
  if(sections && sections.length){
    body.sections = sections;
    body.sections_url = window.location.pathname;
  }
  var res = await fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body)
  });
  var data = await res.json();
  if(res.status >= 400 || (data && data.status && data.status >= 400)){
    var msg = (data && (data.description || data.message)) || ('HTTP ' + res.status);
    var err = new Error(msg);
    err.payload = data;
    throw err;
  }
  return data;
}

function finishCartAdd(cart, response){
  var cartDrawer = document.querySelector('cart-drawer');
  var cartFooter = document.getElementById('main-cart-footer');
  if (cartFooter) cartFooter.classList.toggle('is-empty', response.item_count === 0);
  if (cartDrawer) cartDrawer.classList.toggle('is-empty', response.item_count === 0);
  if(cart && typeof cart.renderContents === 'function'){
    cart.renderContents(response);
  } else {
    window.location = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
  }
}

async function bulkBuyAdd(random) {
  var selectedRadio = document.querySelector('[name="bulk-buy-product"]:checked');
  if(!selectedRadio){
    console.error('No beast size selected — cannot add to cart');
    resetAddToCartButton();
    return;
  }
  var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

  // Main beast box + every PLUS add-on, each as its own cart line item.
  var items = [{
    id: selectedRadio.value,
    quantity: 1,
    properties: getAllProp(random)
  }];
  items = items.concat(getAddonLineItems(random));

  // Diagnostic: confirm in DevTools exactly which variant ids/quantities are sent.
  try { console.log('[bulk-buy] add-to-cart items:', JSON.parse(JSON.stringify(items))); } catch(e){}

  var sections = (cart && typeof cart.getSectionsToRender === 'function')
    ? cart.getSectionsToRender().map(function(s){ return s.id; })
    : null;

  try {
    var response;
    try {
      // Preferred path: add everything in one atomic request.
      response = await addItemsToCart(items, sections);
    } catch(bundleErr){
      // The bundled add was rejected (usually one add-on variant is unavailable or
      // not published to the online store). Add items individually so the valid ones
      // — including the priced PLUS add-ons — still land in the cart.
      console.warn('[bulk-buy] bundled add failed, retrying items individually:', bundleErr.message);
      var added = false, failed = [];
      for (var k = 0; k < items.length; k++){
        try {
          response = await addItemsToCart([items[k]], sections);
          added = true;
        } catch(itemErr){
          failed.push(items[k].id);
          console.error('[bulk-buy] variant could not be added:', items[k].id, itemErr.message);
        }
      }
      if(failed.length){
        alert('Some add-on items could not be added to your cart. Please try again or contact us.');
      }
      if(!added) throw bundleErr;
    }
    finishCartAdd(cart, response);
  } catch(error){
    console.error("Error adding bundle to cart:", error);
    alert('Could not add to cart. Please try again.');
  } finally {
    setTimeout(resetAddToCartButton, 200);
  }
}

function resetAddToCartButton(){
  var btn = document.querySelector('button#bulk-view-cart');
  if(!btn) return;
  btn.classList.remove('loading');
  var spinner = btn.querySelector('.loading__spinner');
  if(spinner) spinner.classList.add('hidden');
  btn.removeAttribute('disabled');
}

if(document.querySelector('.custom-section-popup.bulk-buy-customize-popup button.save-btn')){
  document.querySelector('.custom-section-popup.bulk-buy-customize-popup button.save-btn').onclick = function(){
    saveCustomize();
  }
}

// Reset every Apply button back to its original label. Called when the shopper
// changes a cut option, so a stale "Applied ✓" doesn't linger on an unsaved change.
function bbResetApplyLabel(){
  document.querySelectorAll('span.cstm-apl-btn > a').forEach(function(a){
    if(a.dataset.origLabel){ a.textContent = a.dataset.origLabel; }
    a.classList.remove('is-applied');
  });
}

// Delegated Apply handler — fires for the inline button (product page) and the
// popup button (bulk-buy page) regardless of render timing.
$(document).on('click', 'span.cstm-apl-btn > a', function(evt){
  evt.preventDefault();
  var dataOffRow = document.querySelector('.bulk-buy-row.data-off');
  if(dataOffRow) dataOffRow.classList.remove('data-off');
  optSave();
  // Confirm the selection is saved and KEEP the confirmed state. It only reverts
  // to the original label once the shopper changes an option again (see the
  // 'change' handler above) — this avoids the confusing "Applied -> Apply" flicker
  // that made customers unsure whether their changes had actually applied.
  var link = this;
  if(!link.dataset.origLabel) link.dataset.origLabel = link.textContent;
  link.textContent = 'Applied ✓';
  link.classList.add('is-applied');
});

function optSave(){
  // Walk every cut row, read its currently-checked option, and write that value
  // to the visible gold label AND the hidden source list that feeds cart properties.
  var updated = 0;
  document.querySelectorAll('.bulk-buy-item-main').forEach(function(row){
    var checked = row.querySelector('.bulk-buy-bottom-content input[type="radio"]:checked');
    if(!checked) return;
    var i = row.dataset.index;
    var getText = checked.value.trim();
    // Visible gold cut-type label on the row (inline on product page, in popup on bulk-buy page).
    var label = row.querySelector('.top-left-content p');
    if(label){ label.textContent = getText; updated++; }
    // Hidden source list that feeds cart line-item properties (and the bulk-buy page's order list).
    var cartTitleEl = document.querySelector('.bb-cart__items li[data-index="'+i+'"] .bbc-var-title');
    if(cartTitleEl) cartTitleEl.textContent = getText;
  });
  try { console.log('[bulk-buy] Apply updated ' + updated + ' cut label(s)'); } catch(e){}
  var popMain = document.querySelector('.bulk-buy-items-pop-main');
  if(popMain) popMain.classList.remove('it-change');
  if(typeof closeOptPopup === 'function') closeOptPopup();
}

var clearBtn = document.querySelector('span.clear-cart-bulk-buy');
if(clearBtn){
  clearBtn.addEventListener('click',function(){
    if(!document.querySelector('.bulk-buy-row.data-off')){
      var row = document.querySelector('.bulk-buy-row');
      if(row) row.classList.add('data-off');
    }
    var checked = document.querySelector('.bul-buy-row>input[type=radio]:checked');
    if(checked) checked.checked = false;
    document.querySelectorAll('.bulk-buy-item-main').forEach((ele)=>{
      var lbl = ele.querySelector('label.bb-category');
      if(lbl) lbl.click();
    });
    $('.bulk-buy-bottom-content').slideUp(0);
    $('.top-content').removeClass('its-open');
    var popMain = document.querySelector('.bulk-buy-items-pop-main');
    if(popMain) popMain.classList.remove('it-change');
  });
}

$(document).mouseup(function(e) {
  var container = $('.bulk-buy-items-pop-main');
  if($('.bulk-buy-items-pop-main.active-popup').length){
    if (!container.is(e.target) && container.has(e.target).length === 0){
      closeOptPopup();
    }
  }
  if($('div#shopify-section-custom-pop-up.its-show').length){
    container = $('.pop-up-main');
    if (!container.is(e.target) && container.has(e.target).length === 0){
      if(typeof shipPopupClose === 'function'){
        shipPopupClose();
      }
    }
  }
});









// $(document).ready(function () {
//   $(document).on('click', '.bulk-buy-pre-col', function(){
//     $('body').css('overflow', 'hidden');
//     $('.bulk-buy-items-pop-wrapper').fadeIn(800);
//     $('.bulk-buy-items-pop-main').addClass('active-popup');
//   });
//   $(document).on('click', '.cross-svg', function(){
//     closeOptPopup();
//   });
// });

// // close option popup
// function closeOptPopup(){
//   if(document.querySelector('.bulk-buy-items-pop-main.it-change')){
//     alert('There are unsaved changes. Ensure that you have save your changes before proceeding.');
//   }else{
//     $('body').css('overflow', 'unset');
//     $('.bulk-buy-items-pop-wrapper').fadeOut(800);
//     $('.bulk-buy-items-pop-main').removeClass('active-popup');
//   }
// }

// // auto-select first beast on page load (product template ke liye zaroori)
// document.addEventListener('DOMContentLoaded', function(){
//   var anyChecked = document.querySelector('[name="bulk-buy-product"]:checked');
//   if(!anyChecked){
//     var firstRadio = document.querySelector('[name="bulk-buy-product"]');
//     if(firstRadio){
//       firstRadio.checked = true;
//       firstRadio.dispatchEvent(new Event('change'));
//       // data-off class hata do taki cart content visible ho jaye
//       var row = document.querySelector('.bulk-buy-row.data-off');
//       if(row) row.classList.remove('data-off');
//     }
//   }
// });

// // radio change handlers
// document.querySelectorAll('.bul-buy-row>input[type="radio"]').forEach((ele)=>{
//   ele.onchange = function(){
//     let getWeigth = this.dataset.title;
//     $('.bulk-buy-items-pop-header h2').text(getWeigth);
//     var titleEl = document.querySelector('#custm-title-weight-product');
//     if(titleEl) titleEl.textContent = getWeigth;
//     let price = this.dataset.price;
//     price = moneyFormate(price);
//     var totalPriceEl = document.querySelector('.bulk-buy-cart--total__price span');
//     if(totalPriceEl) totalPriceEl.textContent = price;
//     var totalPriceContainer = document.querySelector('.bulk-buy-cart--total__price');
//     if(totalPriceContainer) totalPriceContainer.setAttribute('data-price', this.dataset.price);
//     var subTotalEl = document.querySelector('.bbp-subT-price');
//     if(subTotalEl) subTotalEl.textContent = price;
//     addPrice();
//     setWeigth();
//   }
// });

// document.querySelectorAll('.top-content').forEach((ele)=>{
//   ele.addEventListener('click',function(){
//     $(this.closest('.bulk-buy-top-content').querySelector('.bulk-buy-bottom-content')).slideToggle(300);
//     if(this.classList.contains('its-open')){
//       this.classList.remove('its-open');
//     }else{
//       this.classList.add('its-open');
//     }
//   });
// });

// document.querySelectorAll('.bulk-buy-bottom-content>input[type="radio"]').forEach((ele)=>{
//     ele.onchange = function(){
//       let i = this.closest('.bulk-buy-item-main').dataset.index;
//       let getText = this.value.trim();
//       this.closest('.bulk-buy-top-content').querySelector('.top-left-content>p').textContent = getText;
//       document.querySelector('.bulk-buy-items-pop-main').classList.add('it-change');
//     }
// });

// // "Choose packing options" trigger — sirf tab chalao jab shipPopup() exist kare
// var packingTrigger = document.querySelector('.bulk-buy-cart_packing__trigger');
// if(packingTrigger){
//   packingTrigger.onclick = function(){
//     if(typeof shipPopup === 'function'){
//       shipPopup();
//     } else {
//       console.warn('shipPopup() not available — popup section may not be loaded on this template');
//     }
//   }
// }

// document.querySelectorAll('.pop-customize-tab-titles span.pop-ctz-tab-title').forEach((ele)=>{
//     ele.addEventListener('click',function(){
//         let i = this.dataset.index;
//         document.querySelectorAll('.pop-customize-tab-titles span.pop-ctz-tab-title').forEach((ele)=>{
//             ele.classList.remove('active-tab');
//         });
//         this.classList.add('active-tab');
//         document.querySelectorAll('.pop-customize-box-tab-cotent').forEach((ele)=>{
//             ele.classList.remove('active-tab-con');
//         });
//         var targetTab = document.querySelector('.pop-customize-box-tab-cotent[data-index="'+i+'"]');
//         if(targetTab) targetTab.classList.add('active-tab-con');
//     })
// });

// // save customize
// function saveCustomize() {
//     var addItemsList = document.querySelector('.bulk-buy-cart-items__main ul.bbc_add__items');
//     if(!addItemsList) return;
//     addItemsList.innerHTML = '';
//     let index = 0;
//     document.querySelectorAll('.pop-ctz-tab-beef-up-item-main quantity-input.quantity').forEach((ele)=>{
//     if(ele.querySelector('.quantity__input').value > 0){
//       index = index+1;
//       let i = ele.closest('.pop-ctz-tab-beef-up-item-main').dataset.index,
//       id = ele.dataset.id,
//       qty = ele.querySelector('.quantity__input').value,
//       price = ele.dataset.price,
//       itemTitle = ele.closest('.pop-ctz-tab-beef-up-item-main').querySelector('span.pop-ctz-tab-beef-item-title>span').textContent;
//       let itemHtml = `<li data-index="${i}" data-id="${id}" data-qty="${qty}" data-price="${price}" data-prop="add item ${index}">
//                           <span class="bbca_pro-title">${itemTitle}</span>
//                           <span class="bbc-add__quatity_mange">
//                             <span class="bbcai_quatity">x${qty}</span>
//                             <span class="bbca_item__remove" data-remove="${i}">
//                               <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="width:15px; height:15px" viewBox="0 0 24 24" preserveAspectRatio="none" width="24" height="24">
//                                 <g><path d="M18 6 6 18M6 6l12 12" stroke="#fff" fill="none" stroke-width="2px"></path></g>
//                               </svg>
//                             </span>
//                           </span>
//                         </li>`;
//       itemHtml = new DOMParser().parseFromString(itemHtml, 'text/html').querySelector('li');
//       document.querySelector('.bbc_add__items').appendChild(itemHtml);
//       document.querySelector('.bulk-buy-cart-add_items__main').style.display = 'block';
//     }
//   });
//   addPrice();
//   if(!document.querySelectorAll('.bulk-buy-cart-items__main ul.bbc_add__items li').length){
//       var addItemsMain = document.querySelector('.bulk-buy-cart-add_items__main');
//       if(addItemsMain) addItemsMain.style.display = 'none';
//   }
//   removeAddonItems();
// }

// // set all item weight
// function setWeigth(){
//   var selectedRadio = document.querySelector('.bul-buy-row>input[type=radio]:checked');
//   if(!selectedRadio) return;
//   document.querySelectorAll('.bbc-pro-qty').forEach((ele)=>{
//     let weight = Number(ele.dataset.qty);
//     let mainWeight = selectedRadio.dataset.weight.replace('kg','').replace('(','');
//     mainWeight = Number(mainWeight.replace(')',''));
//     let oneP = mainWeight/100,
//         raw = oneP*weight,
//         nearest = Math.round(raw);
//     // ITG: snap to whole number if within rounding tolerance of percentage precision
//     let setW;
//     if(Math.abs(raw - nearest) < 0.02){
//       setW = String(nearest);
//     }else{
//       setW = raw.toFixed(2);
//       if(setW.includes('.00')){
//         setW = setW.replace('.00','');
//       }
//     }
//     if(ele.querySelector('.content-weight')){
//       ele.querySelector('.content-weight').textContent = setW+'kg';
//     }else{
//       ele.textContent = setW+'kg';
//     }
//   });
// }

// // add price in product
// function addPrice() {
//   var priceContainer = document.querySelector('.bulk-buy-cart--total__price');
//   if(!priceContainer) return;
//   let addPrice = getAllPrice(),
//    pPrice = priceContainer.dataset.price,
//    tPrice = Number(addPrice)+Number(pPrice),
//    itemPrice = moneyFormate(tPrice),
//    emiPrice = moneyFormate(tPrice/4);
//    document.querySelectorAll('.bulk-buy-cart-header .payment-widget-main span.zip-price').forEach((ele)=>{
//      ele.textContent = emiPrice;
//    });
//    var totalSpan = document.querySelector('.bulk-buy-cart--total__price span');
//    if(totalSpan) totalSpan.textContent = itemPrice;
//    var subTotal = document.querySelector('.bbp-subT-price');
//    if(subTotal) subTotal.textContent = itemPrice;
// }

// // get plus item price
// function getAllPrice() {
//   let allPrice = 0;
//   document.querySelectorAll('.bulk-buy-cart-items__main ul.bbc_add__items li').forEach((ele)=>{
//     let price = ele.dataset.price,
//     qty = ele.dataset.qty;
//     price = price*qty;
//     allPrice = Number(price)+Number(allPrice);
//   });
//   return allPrice;
// }

// // remove add item
// function removeAddonItems() {
//   document.querySelectorAll('span.bbca_item__remove').forEach((ele)=>{
//     ele.addEventListener('click',function(){
//       let i = this.dataset.remove;
//       var qtyInput = document.querySelector('.pop-ctz-tab-beef-up-item-main[data-index="'+i+'"] input.quantity__input');
//       if(qtyInput) qtyInput.value = 0;
//       this.closest('li').remove();
//       if(!document.querySelectorAll('.bulk-buy-cart-items__main ul.bbc_add__items li').length){
//           var addItemsMain = document.querySelector('.bulk-buy-cart-add_items__main');
//           if(addItemsMain) addItemsMain.style.display = 'none';
//       }
//       addPrice();
//     })
//   })
// }

// // create bulk bundle
// function createBulkData(cart,pResponse,random){
//   let itemQty = [],itemId = [],itemData = [];
//   document.querySelectorAll('ul.bbc_add__items li').forEach((ele)=>{
//     itemId.push(ele.dataset.id);
//     itemQty.push(ele.dataset.qty);
//   });
//   for (var i in itemId)
//   itemData.push({id: itemId[i],quantity: itemQty[i],properties:{ _bulkBoxId: random}});
//   return {
//     items:itemData,
//     sections:cart.getSectionsToRender().map((section) => section.id),
//     sections_url:window.location.pathname
//   }
// }

// // add bulk buy
// var addToCartBtn = document.querySelector('button#bulk-view-cart');
// if(addToCartBtn){
//   addToCartBtn.onclick = function(){
//     // Guard 1: ensure ek beast size selected hai
//     var selectedRadio = document.querySelector('[name="bulk-buy-product"]:checked');
//     if(!selectedRadio){
//       var firstRadio = document.querySelector('[name="bulk-buy-product"]');
//       if(firstRadio){
//         firstRadio.checked = true;
//         firstRadio.dispatchEvent(new Event('change'));
//       } else {
//         alert('Please select a beast size first');
//         return;
//       }
//     }
//     this.setAttribute('disabled', true);
//     this.classList.add('loading');
//     var spinner = this.querySelector('.loading__spinner');
//     if(spinner) spinner.classList.remove('hidden');
//     let random = new Date().getTime();
//     bulkBuyAdd(true,random);
//   }
// }

// // get all properties
// function getAllProp(random){
//   let getProp = {
//     _bulkBox: true,
//     _mainBulkBoxId:random
//   }
//   document.querySelectorAll('.bulk-buy-cart-items__main ul.bb-cart__items li').forEach((ele,i)=>{
//     i++;
//     let item = 'item '+i,
//     propLast = ele.querySelector('.bbc-pro-info').textContent.trim();
//     getProp[item] = propLast;
//   });
//   document.querySelectorAll('.bulk-buy-cart-items__main ul.bbc_add__items li').forEach((ele,i)=>{
//     i++;
//     let item = 'add item '+i,
//     propLast = ele.querySelector('.bbca_pro-title').textContent.trim();
//     getProp[item] = propLast;
//   });
//   // Defensive: popup section ka select/textarea optional treat karo
//   var packSelect = document.querySelector('.pop-customize-box-tab-cotent select.pop-select');
//   if(packSelect && packSelect.value){
//     getProp['Pack my beef in'] = packSelect.value;
//   }
//   var packReq = document.querySelector('.pop-customize-box-tab-cotent textarea.pop-input');
//   if(packReq && packReq.value !== ''){
//     getProp['Packing request'] = packReq.value;
//   }
//   return getProp;
// }

// // bulk buy add to cart
// async function bulkBuyAdd(check,random,prevRes) {
//   let getProp = getAllProp(random);
//   let cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
//   var selectedRadio = document.querySelector('[name="bulk-buy-product"]:checked');
//   if(!selectedRadio){
//     console.error('No beast size selected — cannot add to cart');
//     resetAddToCartButton();
//     return;
//   }
//   let mainId = selectedRadio.value,
//       qty = 1,
//       data = {
//         id:mainId,
//         quantity:qty,
//         properties:getProp
//       };
//   // sections only add karo agar cart element mil raha hai
//   if(cart && typeof cart.getSectionsToRender === 'function'){
//     data.sections = cart.getSectionsToRender().map((section) => section.id);
//     data.sections_url = window.location.pathname;
//   }
//   check ? data = data : data = await createBulkData(cart,prevRes,random);
//   fetch("/cart/add.js", {
//     method: "POST",
//     headers: {
//         "Content-Type": "application/json"
//     },
//     body: JSON.stringify(data)
//   }).then(response=>response.json()).then(response=>{
//     if(response.status && response.status >= 400){
//       console.error('Cart add failed:', response);
//       alert(response.description || response.message || 'Could not add to cart');
//       resetAddToCartButton();
//       return;
//     }
//     if(document.querySelectorAll('.bulk-buy-cart-items__main ul.bbc_add__items li').length && check){
//       bulkBuyAdd(false,random,response)
//     }else{
//       let cartDrawer = document.querySelector('cart-drawer');
//       let cartFooter = document.getElementById('main-cart-footer');
//       if (cartFooter) cartFooter.classList.toggle('is-empty', response.item_count === 0);
//       if (cartDrawer) cartDrawer.classList.toggle('is-empty', response.item_count === 0);
//       if(cart && typeof cart.renderContents === 'function'){
//         cart.renderContents(response);
//       } else {
//         // Cart drawer/notification not available — redirect to cart page
//         window.location = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
//       }
//       setTimeout(()=>{
//         resetAddToCartButton();
//       },200);
//     }
//   }).catch(error=>{
//       console.error("Error adding bundle to cart:", error);
//       resetAddToCartButton();
//   })
// }

// // reset Add to Cart button state (loading hatao, enable karo)
// function resetAddToCartButton(){
//   var btn = document.querySelector('button#bulk-view-cart');
//   if(!btn) return;
//   btn.classList.remove('loading');
//   var spinner = btn.querySelector('.loading__spinner');
//   if(spinner) spinner.classList.add('hidden');
//   btn.removeAttribute('disabled');
// }

// // save bulk buy
// var saveBtn = document.querySelector('.custom-section-popup.bulk-buy-customize-popup button.save-btn');
// if(saveBtn){
//   saveBtn.onclick = function(){
//     saveCustomize();
//   }
// }

// // apply option changes
// var applyBtn = document.querySelector('span.cstm-apl-btn>a');
// if(applyBtn){
//   applyBtn.addEventListener('click',function(evt){
//     evt.preventDefault();
//     var row = document.querySelector('.bulk-buy-row.data-off');
//     if(row){
//       row.classList.remove('data-off');
//     }
//     optSave();
//   });
// }

// function optSave(){
//   document.querySelectorAll('.bulk-buy-bottom-content>input[type="radio"]:checked').forEach((ele)=>{
//       let i = ele.closest('.bulk-buy-item-main').dataset.index;
//       let getText = ele.value.trim();
//       ele.closest('.bulk-buy-top-content').querySelector('.top-left-content>p').textContent = getText;
//       var cartItem = document.querySelector('.bb-cart__items li[data-index="'+i+'"] .bbc-var-title');
//       if(cartItem) cartItem.textContent = getText;
//   });
//   var popMain = document.querySelector('.bulk-buy-items-pop-main');
//   if(popMain) popMain.classList.remove('it-change');
//   closeOptPopup();
// }

// // clear bulk buy
// var clearBtn = document.querySelector('span.clear-cart-bulk-buy');
// if(clearBtn){
//   clearBtn.addEventListener('click',function(){
//     var row = document.querySelector('.bulk-buy-row');
//     if(row && !row.classList.contains('data-off')){
//       row.classList.add('data-off');
//     }
//     var checkedRadio = document.querySelector('.bul-buy-row>input[type=radio]:checked');
//     if(checkedRadio) checkedRadio.checked = false;
//     document.querySelectorAll('.bulk-buy-item-main').forEach((ele)=>{
//       var lbl = ele.querySelector('label.bb-category');
//       if(lbl) lbl.click();
//     });
//     $('.bulk-buy-bottom-content').slideUp(0);
//     $('.top-content').removeClass('its-open');
//     var popMain = document.querySelector('.bulk-buy-items-pop-main');
//     if(popMain) popMain.classList.remove('it-change');
//   });
// }

// $(document).mouseup(function(e) {
//   var container = $('.bulk-buy-items-pop-main');
//   if($('.bulk-buy-items-pop-main.active-popup').length){
//     if (!container.is(e.target) && container.has(e.target).length === 0){
//       closeOptPopup();
//     }
//   }
//   if($('div#shopify-section-custom-pop-up.its-show').length){
//     container = $('.pop-up-main');
//     if (!container.is(e.target) && container.has(e.target).length === 0){
//       if(typeof shipPopupClose === 'function'){
//         shipPopupClose();
//       }
//     }
//   }
// });



